module.exports = __webpack_public_path__ + "img/agregar-boton.c0d07f21.svg";